<!--
 * @Author: your name
 * @Date: 2020-12-01 09:25:03
 * @LastEditTime: 2021-10-25 20:06:08
 * @LastEditors: wenjing
 * @Description: In User Settings Edit
 * @FilePath: \xingmahui_front\src\components\archives\growthSituation.vue
-->
<template>
    <div class='container'>

        <div class="growth_situation public_style">
            <div class="title">
                 <div class="view_title">
                   <div class="icon"></div><span>生长情况</span> 
                 </div>
               
                <!-- <div>
                    <div class="view_more"
                        @click="toGrowth">
                        <span><img src="@/assets/images/Profile/profile/jump_more.png" alt=""></span>
                    </div>
                </div> -->
            </div>
            <div class="growth_content">
                <div class="growth_assessment">
                    <!-- 第一个 -->
                    <div class="growth_segment" v-if="growthSituation">

                        <div class="segment_left">
                            <div class="growth_title"><span class="scale">身高</span></div>
                        </div>

                        <div class="segment_center">
                            <div class="pointer"
                                 :style="growthSituation!=null&&growthSituation.height!=0?{left:targetingArea(growthSituation.heightState)+'%'}:{left:'auto',right:'0',paddingTop:'0px',width:'auto'}">
                                <div class="status_labeled">
                                    <div class="character_state" v-if="growthSituation&&growthSituation.height!=0"><span class="scale">{{formatHeight}}cm {{growthSituation?growState(growthSituation.heightState):''}}</span></div>
                                    <div class="down_arrow" v-if="growthSituation&&growthSituation.height!=0"></div>
                                </div>
                                <div class="invalid" v-if="growthSituation&&growthSituation.height==0"><span class="scale">身高数据有误，建议重新测评</span></div>
                            </div>
                            <div class="section">
                                <div class="growth_section growth_section_first"></div>
                                <div class="growth_section growth_section_second"></div>
                                <div class="growth_section growth_section_third"></div>
                                <div class="growth_section growth_section_fourth"></div>
                                <div class="growth_section growth_section_fifth"></div>
                            </div>
                        </div>

                        <div class="segment_right">
                            <div class="describe_text">
                                <span class="scale">{{growthSituation&&growthSituation.heightPercent==null?'低于':'超过'}}{{formatHeightPercent}}%同龄宝宝</span>
                            </div>
                        </div>

                    </div>
                    <div></div>
                    <!-- 第二个 -->
                    <div class="growth_segment" v-if="growthSituation">

                        <div class="segment_left">
                            <div class="growth_title"><span class="scale">体重</span></div>
                        </div>

                        <div class="segment_center">
                            <div class="pointer"
                                 :style="growthSituation!=null&&growthSituation.weight!=0?{left:targetingArea(growthSituation.weightState)+'%'}:{left:'auto',right:'0',paddingTop:'0px',width:'auto'}">
                                <div class="status_labeled">
                                    <div class="character_state" v-if="growthSituation&&growthSituation.weight!=0"><span class="scale">{{formatWeight}}kg {{growthSituation?growState(growthSituation.weightState):''}}</span></div>
                                    <div class="down_arrow" v-if="growthSituation&&growthSituation.weight!=0"></div>
                                </div>
                                <div class="invalid" v-if="growthSituation&&growthSituation.weight==0"><span class="scale">体重数据有误，建议重新测评</span></div>
                            </div>
                            <div class="section">
                                <div class="growth_section growth_section_first"></div>
                                <div class="growth_section growth_section_second"></div>
                                <div class="growth_section growth_section_third"></div>
                                <div class="growth_section growth_section_fourth"></div>
                                <div class="growth_section growth_section_fifth"></div>
                            </div>
                        </div>

                        <div class="segment_right">
                            <div class="describe_text">
                                <span class="scale">{{growthSituation&&growthSituation.weightPercent==null?'低于':'超过'}}{{formatWeightPercent}}%同龄宝宝</span>
                            </div>
                        </div>

                    </div>
                    <div></div>
                    <!-- 第三个 -->
                    <div class="growth_segment"
                         v-if="growthSituation&&showHeadState">

                        <div class="segment_left">
                            <div class="growth_title"><span class="scale">头围</span></div>
                        </div>

                        <div class="segment_center">
                            <div class="pointer"
                                 :style="growthSituation!=null&&growthSituation.head!=0&&growthSituation.head!=null?{left:targetingArea(growthSituation.headState)+'%'}:{left:'auto',right:'0',paddingTop:'0px',width:'auto'}">
                                <div class="status_labeled">
                                    <div class="character_state" v-if="growthSituation&&growthSituation.head!=0"><span class="scale" v-if="growthSituation&&growthSituation.head!=null">{{formatHead}}cm {{growthSituation?growState(growthSituation.headState,3):''}}</span></div>
                                    <span v-if="growthSituation&&growthSituation.head!=null"><div class="down_arrow" v-if="growthSituation&&growthSituation.head!=0"></div></span>
                                </div>
                                <div class="invalid" v-if="growthSituation&&growthSituation.head==0||growthSituation.head==null"><span class="scale">头围数据有误，建议重新测评</span></div>
                            </div>
                            <div class="section">
                                <div class="growth_section growth_section_first"></div>
                                <div class="growth_section growth_section_second"></div>
                                <div class="growth_section growth_section_third"></div>
                                <div class="growth_section growth_section_fourth"></div>
                                <div class="growth_section growth_section_fifth"></div>
                            </div>
                        </div>

                        <div class="segment_right">
                            <div class="describe_text">
                                <span class="scale">{{growthSituation&&growthSituation.headPercent==null?'低于':'超过'}}{{formatHeadPercent}}%同龄宝宝</span>
                            </div>
                        </div>

                    </div>
                    <div></div>
                    <!-- 第四个 -->
                    <div class="growth_segment" v-if="growthSituation">

                        <div class="segment_left">
                            <div class="growth_title growth_title_bmi"><span class="scale">BMI</span></div>
                        </div>

                        <div class="segment_center">
                            <div class="pointer"
                                 :style="growthSituation!=null&&growthSituation.bmi!=null?{left:targetingArea(growthSituation.bmiState)+'%'}:{left:'auto',right:'0',paddingTop:'0px',width:'auto'}">
                                <div class="status_labeled">
                                    <div class="character_state" v-if="growthSituation&&growthSituation.bmi!=null"><span class="scale">{{formatBmi}} {{growthSituation?growState(growthSituation.bmiState):''}}</span></div>
                                    <div class="down_arrow" v-if="growthSituation&&growthSituation.bmi!=null"></div>
                                </div>
                                <div class="invalid" v-if="growthSituation&&growthSituation.bmi==null"><span class="scale">身高或体重数据异常，无法计算BMI</span></div>
                            </div>
                            <div class="section">
                                <div class="growth_section growth_section_first"></div>
                                <div class="growth_section growth_section_second"></div>
                                <div class="growth_section growth_section_third"></div>
                                <div class="growth_section growth_section_fourth"></div>
                                <div class="growth_section growth_section_fifth"></div>
                            </div>
                        </div>

                        <div class="segment_right">
                            <div class="describe_text">
                                <span class="scale">{{growthSituation&&growthSituation.bmiPercent==null?'低于':'超过'}}{{formatBmiPercent}}%同龄宝宝</span>
                            </div>
                        </div>

                    </div>

                    <div class="growth_describe" v-if="growthSituation">

                        <div class="description">
                            <div class="description_left growth_section_first"></div>
                            <div class="description_right"><span class="scale">偏低</span></div>
                        </div>

                        <div class="description">
                            <div class="description_left growth_section_second"></div>
                            <div class="description_right"><span class="scale">略低</span></div>
                        </div>

                        <div class="description">
                            <div class="description_left growth_section_third"></div>
                            <div class="description_right"><span class="scale">正常</span></div>
                        </div>

                        <div class="description">
                            <div class="description_left growth_section_fourth"></div>
                            <div class="description_right"><span class="scale">略高</span></div>
                        </div>

                        <div class="description">
                            <div class="description_left growth_section_fifth"></div>
                            <div class="description_right"><span class="scale">偏高</span></div>
                        </div>
                    </div>

                    <div class="have_baby"
                         v-if="growthSituation"
                         :style="showRecordsBaby? '':{display:'none'}"
                         @click="goAddGrowth1"
                         ><span class="scale">您已经超过{{showRecordsBaby}}个月没有记录宝宝的生长情况了，快去<span class="jump">添加</span>吧~</span></div>

                    <!-- <div class="evaluation_time"
                         v-if="!newRecord&&evaluationTime!=''">测评时间：{{formatYear}}年{{formatMonth}}月{{formatDay}}日/{{growthSituation.monthAge}}</div> -->

                    <div class="no_baby_info"
                         v-if="!growthSituation"
                         @click="goAddGrowth"
                         >
                         <!-- <span class="scale">还没有宝宝的数据哦，快去<span class="jump">添加</span>吧~</span> -->
                         <div class="no_file">
                            <div>
                                <img
                                    src="@/assets/images/Profile/profile/no_baby_data.png"
                                    alt=""
                                />
                                <p>输入身高体重，跟同龄<span>"宝宝PK"</span>一下吧～</p>
                                </div>
                            </div>
                         </div>

                </div>

            </div>

        </div>

    </div>
</template>

<script>
export default {
    name: "growthSituation",
    data () {
        return {

        }
    },
    props: {
        growthSituation: {
            type: Object,
            default: function () {
                return {}
            }
        },
        showRecordsBaby: {
            type: String,
            default: ''
        },
        evaluationTime: {
            type: String,
            default: ''
        },
        // 控制测评时间显隐
        showEvaluationTime: {
            type: Boolean,
            default: false
        },
        // 是否是最新测评页面
        newRecord: {
            type: Boolean,
            default: true
        },
        showHeadState: {
            type: Boolean,
            default: false
        },
        num: {
            type: Number,
            default: 0
        }
    },
    computed: {
        formatHeightPercent() {
            if (this.growthSituation) {
                if (this.growthSituation.height == 0) {
                    return '--'
                } else {
                    if (this.growthSituation.heightPercent) {
                        return this.growthSituation.heightPercent
                    } else {
                        return '97'
                    }
                }
            }
        },
        formatWeightPercent() {
            if (this.growthSituation) {
                if (this.growthSituation.weight == 0) {
                    return '--'
                } else {
                    if (this.growthSituation.weightPercent) {
                        return this.growthSituation.weightPercent
                    } else {
                        return '97'
                    }
                }
            }
        },
        formatHeadPercent() {
            if (this.growthSituation) {
                if (this.growthSituation.head == 0 || this.growthSituation.head == null) {
                    return '--'
                } else {
                    if (this.growthSituation.headPercent) {
                        return this.growthSituation.headPercent
                    } else {
                        return '97'
                    }
                }
            }
        },
        formatBmiPercent() {
            if (this.growthSituation) {
                if (this.growthSituation.bmi == null) {
                    return '--'
                } else {
                    if (this.growthSituation.bmiPercent) {
                        return this.growthSituation.bmiPercent
                    } else {
                        return '97'
                    }
                }
            }
        },
        formatWrongData() {
            if (this.growthSituation.head==0||this.growthSituation.head==null) {
                return false
            } else {
                return true
            }
        },
        formatHeight() {
            if (this.growthSituation&&this.growthSituation.height) {
                this.$emit("getThree",{height:(this.growthSituation.height / 10).toFixed(1)})
                return (this.growthSituation.height / 10).toFixed(1)
            }
        },
        formatWeight() {
            if (this.growthSituation&&this.growthSituation.weight) {
                this.$emit("getThree",{weight:(this.growthSituation.weight / 1000).toFixed(2)})
                return (this.growthSituation.weight / 1000).toFixed(2)
            }
        },
        formatHead() {
            if (this.growthSituation&&this.growthSituation.head) {
                this.$emit("getThree",{head:(this.growthSituation.head).toFixed(1)})
                return (this.growthSituation.head).toFixed(1)
            }
        },
        formatBmi() {
            if (this.growthSituation&&this.growthSituation.bmi) {
                return (this.growthSituation.bmi).toFixed(1)
            }
        }
    },
    mounted () {
        
    },
    methods: {
        growState: function (num, str) {
            if (!num) {
                return '正常'
            }
            if (str == 3) {
                switch (num) {
                    case '1':
                        return '偏小'
                    case '2':
                        return '略小'
                    case '3':
                        return '正常'
                    case '4':
                        return '略大'
                    case '5':
                        return '偏大'
                    default:
                        return ''
                }
            } else {
                switch (num) {
                    case '1':
                        return '偏低'
                    case '2':
                        return '略低'
                    case '3':
                        return '正常'
                    case '4':
                        return '略高'
                    case '5':
                        return '偏高'
                    default:
                        return ''
                }
            }
        },
        // 落在哪个区域
        targetingArea (state) {
            switch (state) {
                case '1':
                    return '10'
                case '2':
                    return '30'
                case '3':
                    return '50'
                case '4':
                    return '70'
                case '5':
                    return '90'
                default:
                    return ''
            }
        },
        toGrowth () {
            if(this.growthSituation){
                location.href = "/evaluationResult?num=" + + this.growthSituation.childNumber + '&sex='+ this.growthSituation.bmiData.sex.toUpperCase() + '&sourceFrom=babyArchives';

            }else{
                this.goAddGrowth()
            }
            //this.$router.push({ path: '/evaluationResult?num=' + this.growthSituation.childNumber + '&sex='+ this.growthSituation.bmiData.sex.toUpperCase() + '&sourceFrom=babyArchives' })
        },
        goAddGrowth () {
          if(this.num){
            location.href = '/startAssessment?num=' + this.num +'&sourceFrom=babyArchives';
          }
        },
        goAddGrowth1 () {
          location.href = '/startAssessment?num='+this.growthSituation.childNumber+'&sourceFrom=babyArchives';
        }
    },
}
</script>

<style scoped lang='less'>
.container {
  width: 351px;
  margin: 0 auto;
}
// 生长情况
.growth_situation {
  background-color: #fff;
  padding-bottom: 14px;
  color: #333;
  .title {
    height: 18px;
    // line-height: 18px;
    padding-top: 14px;
    font-size: @indexFontSize18;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .view_title{
      display: inline-block;
      font-weight: 600;
    }
    span{
      display: inline-block;
    }
    .icon {
      position: relative;
      top: 3px;
      display: inline-block;
      width: 6px;
      height: 18px;
      border-radius: 3px;
      margin-right: 4px;
      background-color: #ffa5a5;
    }
  }
  .view_more {
    height: 12px;
    font-size: @indexFontSize12;
    // line-height: 12px;
    float: right;
    display: flex;
    align-items: center;
    img {
      width: 12px;
      height: 10px;
      display: block;
      float: right;
    }
  }
  .growth_content {
    color: #979593;
    .have_baby {
      color: #666;
      margin-top: 4px;
      .scale {
        font-size: 10px;
        transform: scale(10/12);
      }
    }
    .jump {
      font-size: 16px;
      color: rgba(1, 121, 255, 1);
      text-decoration: none;
    }
    .no_baby_info {
      color: #666666;
      text-align: center;
      font-size: 12px;
    //   margin: 40px 0 0 0;
      .scale {
        font-size: 12px;
        // transform: scale(10/12);
      }
      .no_file {
        padding: 50px 0px 18px 0px;
       div{
        text-align: center;
        img {
          width: 171px;
          height: 131px;
        }
        p {
          margin-top: 6px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          span{
              color:#F1BC3F;
          }
        }
      }
    }
    }

    .growth_assessment {
      width: 100%;
      height: 100%;
      padding-top: 6px;
      .growth_segment {
        width: 100%;
        height: 35px;
        display: flex;
        padding-top: 10px;
        .segment_left {
          color: #333;
        //   width: 24px;
        //   box-sizing: border-box;
          float: left;
          padding-top: 23px;
          line-height: 1.3;
          .growth_title {
            .scale {
              font-size: 10px;
              transform: scale(10/12);
            }
            // float: left;
            // height: 10px;
            // font-size: 10px;
          }
        }
        .segment_center {
        //   width: 216px;
        //   width: 170px;
          flex: 1;
          height: 35px;
          float: left;
          margin-left: 4px;
          margin-right: 4px;
          position: relative;
          padding-top: 25px;
          box-sizing: border-box;
          .pointer {
            margin-left: -33px;
            margin-top: -10px;
            position: absolute;
            top: 11px;
            left: 50%;
            .scale {
              font-size: 10px;
              transform: scale(10/12);
              white-space: nowrap;
            }
            .status_labeled {
                width: 70px;
                .down_arrow {
                  width: 12px;
                  height: 7px;
                  background-image: url('../../../assets/images/icon/tick​Arrow.png');
                  background-size: 100% 100%;
                  margin: 0 auto;
                }
                .character_state {
                  height: 14px;
                  line-height: 14px;
                  font-size: 10px;
                  color: #666;
                  margin-left: 2px;
                  padding-top: 1px;
                  padding-bottom: 3px;
                  box-sizing: border-box;
                  text-align: center;
                }
            }
            .invalid {
              color: #666;
            }
          }
          .section {
            width: 100%;
            height: 10px;
            // padding-top: 25px;
            .growth_section {
              width: 20%;
              height: 10px;
              float: left;
            }
          }
        }
        .segment_right {
          color: #333;
          padding-top: 23px;
          float: right;
          line-height: 1.3;
          .describe_text {
            .scale {
              font-size: 10px;
              transform: scale(10/12);
            }
          }
        }
      }
      .growth_describe {
        width: 239px;
        height: 34px;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        margin-right: 90px;
        .description {
          display: flex;
          flex-flow: nowrap;
          .description_left {
            align-self: center;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            border-radius: 7/2px;
          }
          .description_right {
            color: #666;
            margin-left: 4px;
            justify-content: end;
            .scale {
              font-size: 10px;
              transform: scale(10/12);
            }
          }
        }
      }
      .evaluation_time {
        margin-top: 8px;
      }
    }
  }
}

.growth_section_first {
  background-color: #3d83de;
  border-radius: 5px 0 0 5px;
}
.growth_section_second {
  background-color: #7ac2f5;
}
.growth_section_third {
  background-color: #35c89a;
}
.growth_section_fourth {
  background-color: #ffbe6f;
}
.growth_section_fifth {
  background-color: #ff8b65;
  border-radius: 0 5px 5px 0;
}

.public_style {
  margin-bottom: 10px;
  border-radius: 8px;
  padding: 0 14px;
  padding-bottom: 14px;
}

.growth_title_bmi {
    padding-right: 1px;
}


</style>
